import React from "react";

// DeviceBadge: compact modern badge with soft gradient and subtle glow when playing
export const DeviceBadge = ({ playing }) => {
    return (
        <div
            className="relative w-14 h-14 rounded-xl flex items-center justify-center shadow-2xl"
            style={{
                background: "var(--color-secondary)",
            }}
            aria-hidden="true"
        >
            <svg
                className="w-7 h-7"
                style={{ color: "var(--color-white)" }}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21 7.5h-3.2l-1.6-2.4A1 1 0 0 0 15.6 4H8.4a1 1 0 0 0-.6.1L6.2 6.5H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zM12 17a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                    fill="currentColor"
                />
                <circle
                    cx="12"
                    cy="13"
                    r="2"
                    fill="var(--color-white)"
                    opacity="0.95"
                />
            </svg>

            {playing && (
                <span
                    className="absolute -right-1 -bottom-1 w-3.5 h-3.5 rounded-full border-2"
                    style={{
                        borderColor: "var(--color-white)",
                        background: "var(--color-teal)",
                        boxShadow: "0 6px 18px rgba(16,185,129,0.24)",
                    }}
                />
            )}
        </div>
    );
};

export default DeviceBadge;
